module.exports = __webpack_public_path__ + "img/vehicle_pin_attention.d4f9a166.svg";